import React, { useState, useEffect } from 'react';
import { useChat } from '../../contexts/ChatContext';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import UserList from './UserList';
import './ChatWindow.css';

const ChatWindow: React.FC = () => {
  const { state: chatState, sendMessage, clearError, isAvailable } = useChat();
  const [showUserList, setShowUserList] = useState(true);

  // Очистка ошибки через 3 секунды
  useEffect(() => {
    if (chatState.error && isAvailable) {
      const timer = setTimeout(() => {
        clearError();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [chatState.error, clearError, isAvailable]);

  // Если чат недоступен, показываем сообщение об ошибке
  if (!isAvailable) {
    return (
      <div className="chat-container">
        <div className="chat-error">
          {chatState.error || 'Чат недоступен'}
        </div>
      </div>
    );
  }

  return (
    <div className="chat-container">
      {chatState.error && (
        <div className="chat-error">
          {chatState.error}
        </div>
      )}
      
      {!chatState.isConnected && !chatState.error && (
        <div className="chat-connecting">
          Подключение к чату...
        </div>
      )}
      
      {chatState.isConnected && (
        <>
          <div className="chat-main">
            <MessageList messages={chatState.messages} />
            {showUserList && (
              <UserList users={chatState.users} />
            )}
          </div>
          
          <div className="chat-controls">
            <button 
              className="toggle-users-btn"
              onClick={() => setShowUserList(!showUserList)}
              title={showUserList ? 'Скрыть список игроков' : 'Показать список игроков'}
            >
              {showUserList ? '👥' : '👤'}
            </button>
            <MessageInput onSendMessage={sendMessage} />
          </div>
        </>
      )}
    </div>
  );
};

export default ChatWindow;
